import React, { useEffect, useState, useCallback } from "react";
import {
    CardContent,
    CardHeader,
    Grid,
    Button,
    Stack,
    Alert, CardActions,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { updateThemes } from "../../Redux/Action";
import {Loader,FormCard} from "../../../../../Components";
import {JsonThemeEditor} from "../../../../../Components/Elements/JsonThemeEditor";
import {previewTheme as previewThemeAction, restoreTheme as restoreThemeAction} from "../../../../Common/App";

export const PreviewTab = ({isLoading, setIsLoading}) => {

    const dispatch = useDispatch();
    const item = useSelector((store) => store.themes.selected);
    const previewTheme = useSelector((store) => store.themes.preview);
    const [isPreviewOn, setIsPreviewOn] = useState(false);
    const [, setEditMode] = useState(false);
    const [data, setData] = useState({
        id: "",
        name: "",
        properties: {},
    });
    const [, setErrors] = useState({});
    const [, setMessage] = useState("");

    // Populate `data` when `item` changes
    useEffect(() => {
        if (item) {
            setData({
                id: item.id || "",
                name: item.name || "",
                properties: item.properties || {},
            });
        }
    }, [item]);

    const handleChange = useCallback(
        (e) => {
            const { name, value } = e.target;
            setData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: "",
            }));
        },
        [setData]
    );

    const handleSave = async () => {
        setIsLoading(true);
        await updateThemes({dispatch, data}).then((res) => {
            if(res['success']){
                setEditMode(false);
            }
            setIsLoading(false);
            setErrors(res.errors);
            setMessage(res.message);
        });
    };

    const handleCancel = () => {
        setEditMode(false);
        setErrors({});
        setData({
            id: item.id || "",
            name: item.name || "",
            properties: item.properties || {},
        });
    };

    const handlePreviewTheme = useCallback(async () => {
        setIsPreviewOn(true);
        dispatch(previewThemeAction(data?.properties));
    }, [dispatch, data?.properties]);

    const handleRestoreTheme = useCallback(async () => {
        dispatch(restoreThemeAction());
        setIsPreviewOn(false);
    }, [dispatch]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <FormCard>
                    <CardHeader
                        title={item?.name || "Theme Preview"}
                        subheader={
                            item?.is_active 
                                ? "This theme is currently active. No preview needed." 
                                : previewTheme?.id 
                                    ? "Previewing theme changes (temporary)" 
                                    : item?.name 
                                        ? "Edit theme properties and preview changes" 
                                        : "Select a theme to configure"
                        }
                        action={
                            item?.id && !item?.is_active ? (
                                !isPreviewOn ? (
                                    <Button color={"success"} onClick={handlePreviewTheme} variant="contained">
                                        Preview
                                    </Button>
                                ) : (
                                    <Button color={"info"} onClick={handleRestoreTheme} variant="contained">
                                        Restore
                                    </Button>
                                )
                            ) : null
                        }
                        avatar={<Loader isLoading={isLoading} type={"linear"}/>}
                    />
                    <CardContent sx={{pb:'1rem!important'}}>
                        {item?.id ? (
                            <JsonThemeEditor
                                value={data?.properties ?? {}}
                                name={"properties"}
                                onChange={handleChange}
                            />
                        ) : (
                            <Alert severity="info" sx={{ textAlign: 'center', py: 4 }}>
                                <strong>No Theme Selected</strong><br/>
                                Please select a theme from the sidebar to start configuring.
                            </Alert>
                        )}
                    </CardContent>
                    {item?.id && (
                        <CardActions sx={{ p:2, justifyContent: "flex-end"}}>
                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleCancel}
                                    disabled={isLoading}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSave}
                                    disabled={isLoading}
                                >
                                    Save Theme
                                </Button>
                            </Stack>
                        </CardActions>
                    )}
                </FormCard>
            </Grid>
        </Grid>
    );
};
